<% var platforms = I18n.platforms[validated_appointment_slot.visit_type_category] %>

<% if (platforms) { %>
  <label class="field-label"><%= I18n.confirmation.labels.platform.replace('%{visit_type}', validated_appointment_slot.visit_type_name) %></label>
  <div class="field-input select">
    <select data-appointment-booking-wizard-behaviour="field-input" name="platform" >
      <% jQuery.each(platforms, function(key, value) { %>
          <option value="<%- key %>"><%- value.label %></option>
      <% }) %>
    </select>
  </div>
  <div class="platform-callout-container"></div>
<% } %>
